import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const operatorDashboardApi = {
  getDashboard: (equipmentId) =>
    axios.get(`${API}/operator-dashboard/equipment/${equipmentId}`),

  getLive: (equipmentId) =>
    axios.get(`${API}/operator-dashboard/equipment/${equipmentId}/live`),

  // Trilha pelo MESMO endpoint do dashboard principal (gated por equipment access,
  // que a conta kiosk possui). Desacopla a trilha do payload pesado do operator.
  getTrail: (equipmentId, hours = 24) =>
    axios.get(`${API}/dashboard/equipment/${equipmentId}/trail`, { params: { hours } }),
};

export default operatorDashboardApi;
